<div class="container-fluid m-0 p-0" *ngIf="!showLoader">

    <form [formGroup]="createCourse" (change)="createCourseChange()" (submit)="createCourseSubmit()">



        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">{{"CREATE_COURSE" | translate | titlecase }}</h6>
            </div>
            <div class="col-md-6 d-flex flex-wrap justify-content-center justify-content-lg-end">
                <button type="button" class="btn btn-outline-secondary m-2 rounded-0" routerLink="/enrolment/courses"
                    *ngIf="!creating">
                    {{"CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!creating"><i
                        class="fas fa-user-plus"></i>
                    {{"SAVE" | translate | titlecase }}</button>
                <app-loader [show]="creating"></app-loader>
            </div>


        </div>

        <div class="row mt-4">

            <div class="col-12">

                <div class="row bg-white border m-0 py-3 ">
                    <!-- <div class="col-md-10 mx-md-auto pt-md-5 px-md-5">
                        <img src="assets/images/avatar.png" class="img-fluid">
                    </div> -->

                    <div class="col-md-10 mx-md-auto py-3">
                        <div class="row">
                            <!-- <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">User Status</label>
                                <select class="form-control custom-select" readonly disabled>
                                    <option value="">Select</option>
                                    <option value="Activated" selected>Activated</option>
                                </select>
                            </div> -->
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"SUBJECT_CODE" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="subjectCode">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createCourse.controls.subjectCode.touched && createCourse.controls.subjectCode.invalid && createCourse.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"SUBJECT_NAME_EN" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="subjectNameEn">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createCourse.controls.subjectNameEn.touched && createCourse.controls.subjectNameEn.invalid && createCourse.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"SUBJECT_NAME_AR" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="subjectNameAr">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createCourse.controls.subjectNameAr.touched && createCourse.controls.subjectNameAr.invalid && createCourse.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"CLASS_HOURS" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="classHours">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createCourse.controls.classHours.touched && createCourse.controls.classHours.invalid && createCourse.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"CLINICAL_HOURS" | translate | titlecase }}</label>
                                <input type="input" class="form-control" formControlName="clinicalHours">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createCourse.controls.clinicalHours.touched && createCourse.controls.clinicalHours.invalid && createCourse.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"TOTAL_HOURS" | translate | titlecase }}</label>
                                <input type="input" class="form-control" formControlName="totalHours" readonly>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createCourse.controls.totalHours.touched && createCourse.controls.totalHours.invalid && createCourse.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"CREDIT_HOURS" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="creditHours">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createCourse.controls.creditHours.touched && createCourse.controls.creditHours.invalid && createCourse.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"PASS_GRADE" | translate | titlecase }}</label>
                                <input type="input" class="form-control" formControlName="passGrade">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createCourse.controls.passGrade.touched && createCourse.controls.passGrade.invalid && createCourse.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"MINI_ATTEND_HOURS" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="miniAttendHours">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createCourse.controls.miniAttendHours.touched && createCourse.controls.miniAttendHours.invalid && createCourse.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createCourse.hasError('checkClassHoursMinValue')">
                                    {{"MINI_ATTEND_HOURS_SHOULD_LESS_THAN_OR_EQUAL_CLASS_HOURS" | translate |
                                    titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"MINI_LAB_HOURS" | translate | titlecase }}</label>
                                <input type="input" class="form-control" formControlName="miniLabHours">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createCourse.controls.miniLabHours.touched && createCourse.controls.miniLabHours.invalid && createCourse.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createCourse.hasError('checkClinicalHoursMinValue')">
                                    {{"MIN_LAB_HOURS_SHOULD_LESS_THAN_OR_EQUAL_CLASS_HOURS" | translate |
                                    titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"FULL_DEGREE" | translate | titlecase }}</label>
                                <input type="input" class="form-control" formControlName="fullDegree">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createCourse.controls.fullDegree.touched && createCourse.controls.fullDegree.invalid && createCourse.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>

                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"PRE_REQUISIT_COURSES" | translate | titlecase }}</label>
                                <!-- <input type="text" class="form-control"> -->
                                <ng-multiselect-dropdown placeholder="{{'SELECT' | translate | titlecase }}"
                                    [settings]="dropdownSettings" [data]="courses"
                                    [(ngModel)]="CourseSelectedPreRequisite" formControlName="preRequisit"
                                    (onSelect)="onItemSelect($event)">
                                </ng-multiselect-dropdown>

                                <div class="alert alert-danger px-3 p-1 mt-1"
                                    *ngIf="createCourse.controls.preRequisit.touched && createCourse.controls.preRequisit.invalid && createCourse.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>

                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"CO_REQUISIT_COURSES" | translate | titlecase }}</label>
                                <!-- <input type="text" class="form-control"> -->
                                <ng-multiselect-dropdown placeholder="{{'SELECT' | translate | titlecase }}"
                                    [settings]="dropdownSettings" [data]="courses"
                                    [(ngModel)]="CourseSelectedCoRequisite" formControlName="coRequisit"
                                    (onSelect)="onItemSelect($event)">
                                </ng-multiselect-dropdown>

                                <div class="alert alert-danger px-3 p-1 mt-1"
                                    *ngIf="createCourse.controls.preRequisit.touched && createCourse.controls.preRequisit.invalid && createCourse.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>

                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"CATEGORY" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="category">
                                    <option value="" >{{"SELECT" | translate | titlecase }}</option>
                                    <option *ngFor="let res of courseCategories" [ngValue]="res.id">{{
                                        (globals.lang == 'ar')? res.scatNameAr : res.scatNameEn
                                        }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createCourse.controls.category.touched && createCourse.controls.category.invalid && createCourse.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>

                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"FINAL_EXAM_DURATION_HRS" | translate | titlecase }}</label>
                                <input type="input" class="form-control" formControlName="finalExamDuration">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createCourse.controls.finalExamDuration.touched && createCourse.controls.finalExamDuration.invalid && createCourse.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>

                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"EXAM_GRADES_FINAL" | translate | titlecase }}</label>
                                <input type="input" class="form-control" formControlName="final">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createCourse.controls.final.touched && createCourse.controls.final.invalid && createCourse.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>

                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"EXAM_GRADES_ONGOING" | translate | titlecase }}</label>
                                <input type="input" class="form-control" formControlName="ongoing">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createCourse.controls.ongoing.touched && createCourse.controls.ongoing.invalid && createCourse.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>

                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"MARK_GROUP" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="markGroup">
                                    <option value="" >{{"SELECT" | translate | titlecase }}</option>
                                    <option *ngFor="let res of markGroups" [ngValue]="res.id">{{
                                        (globals.lang == 'ar')? res.mgroupNameAr : res.mgroupNameEn
                                        }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="createCourse.controls.markGroup.touched && createCourse.controls.markGroup.invalid && createCourse.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<app-loader [attr.show]="showLoader"></app-loader>